import type { ReactNode } from "react";
import { IconOrders, IconPositions, IconChart } from "../components/icons";

function Placeholder({ icon, title, desc, roadmap }: { icon: ReactNode; title: string; desc: string; roadmap: string[] }) {
  return (
    <div className="panel">
      <div className="empty">
        <div className="icon">{icon}</div>
        <h3>{title}</h3>
        <p>{desc}</p>
        <div className="roadmap">
          {roadmap.map((r, i) => (
            <div key={i}><span className="dot" /> {r}</div>
          ))}
        </div>
      </div>
    </div>
  );
}

export const Orders = () => (
  <Placeholder
    icon={<IconOrders size={52} />}
    title="订单管理"
    desc="集中查看与管理各执行器的委托：实时委托状态、成交回报、撤单、拆单进度。"
    roadmap={[
      "对接 BaseTrader.query_order / 成交回报（OrderFilledEvent）",
      "委托列表：状态 / 方向 / 数量 / 均价 / 滑点，按执行器与标的筛选",
      "TWAP / 冰山拆单进度可视化（AlgoTrader）",
      "一键撤单与手动干预",
    ]}
  />
);

export const Positions = () => (
  <Placeholder
    icon={<IconPositions size={52} />}
    title="仓位管理"
    desc="组合级持仓总览：各策略/标的的净头寸、均价、浮动盈亏，以及与券商的对账偏差。"
    roadmap={[
      "策略内存仓位 + SharedContext 快照聚合",
      "多空净头寸、总敞口、单标的净头寸（对齐 RiskGuard）",
      "券商实际持仓对账（reconcile_all）与漂移告警",
      "已实现 / 未实现盈亏与风控熔断状态联动",
    ]}
  />
);

export const Charts = () => (
  <Placeholder
    icon={<IconChart size={52} />}
    title="指标图表"
    desc="高频微观因子与量价的可视化：等额 K 线、OIM 订单失衡、聪明钱、资金费率 / 持仓量 / 多空比。"
    roadmap={[
      "K 线 + 等额 K 线（EquiVolume）叠加",
      "OIM / 净流入 / Z-Score 因子曲线",
      "资金费率、持仓量、多空比、爆仓热力",
      "现货信号 vs 合约执行的对照视图",
    ]}
  />
);
